import React, { Component } from 'react';
import { callPlayer, getSDK } from 'react-player/lib/utils';
import { connect } from 'react-redux';
import { getVideo } from './API';
import { v4 } from 'uuid';

const cueTvMediaUrlRegex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/).*cuetv\.online.*/g;

const uuidv4 = () => {
  return 'cuetv_' + v4();
};

const generateVideoFrameElement = (videoUrl, cueTvVideo, videoId) => {
  const ifrm = document.createElement('iframe');
  ifrm.setAttribute('src', videoUrl);
  ifrm.setAttribute('id', videoId);
  ifrm.setAttribute('frameborder', 0);
  ifrm.setAttribute('webkitAllowFullScreen', 1);
  ifrm.setAttribute('mozallowfullscreen', 1);
  ifrm.setAttribute('allowFullScreen', 1);
  ifrm.title = cueTvVideo.name;

  return ifrm;
};

const generateThumbnailFrameElement = (imgUrl, cueTvVideo, videoId, reDirectUrl) => {
  const thumbnailContainer = document.createElement('a');
  thumbnailContainer.setAttribute('href', reDirectUrl);
  thumbnailContainer.setAttribute('target', '_blank');
  thumbnailContainer.setAttribute('id', videoId);
  const playIcon = document.createElement('img');
  playIcon.setAttribute('src', '/images/icons/cuetv-play.png');
  playIcon.classList.add('icon');

  const elem = document.createElement('img');
  elem.setAttribute('src', imgUrl);
  elem.classList.add('imgStyle');
  thumbnailContainer.appendChild(elem);
  thumbnailContainer.appendChild(playIcon);
  return thumbnailContainer;
};

const generateWatchLinkElement = (url, watchLinkContainerId) => {
  const watchLink = document.createElement('a');
  // var icon =<PlayArrowIcon/>
  watchLink.setAttribute('href', url);
  watchLink.setAttribute('target', '_blank');
  watchLink.setAttribute('title', 'Watch on CueTV');
  watchLink.innerHTML = 'Watch on CueTV';

  const watchLinkContainer = document.createElement('div');
  watchLinkContainer.setAttribute('id', watchLinkContainerId);
  watchLinkContainer.appendChild(watchLink);

  return watchLinkContainer;
};

const generateStyleElement = (containerId, videoId, watchLinkContainerId) => {
  const style = document.createElement('style');
  style.innerHTML = `
  #${videoId} {
    height: 100%;
    width: 100%;
}

#${containerId} {
    height: 100%;
    width: 100%;
    position: relative;
}

#${containerId}:hover #${watchLinkContainerId} {
    display: block !important;
}

#${watchLinkContainerId} {
    position: absolute;
    display: none;
    padding: 5px;
    background: rgba(0, 0, 0, 0.5);
    top: 20px;
    left: 20px;
}

#${watchLinkContainerId} > a {
    text-decoration: underline;
    color: #fff;
    font-size: 20px;
    line-height: 20px;
}`;

  return style;
};

const generateThumbnailStyleElement = (containerId, videoId) => {
  const style = document.createElement('style');
  style.innerHTML = `
  #${videoId} {
    display: block;
    height: 100%;
    width: 100%;
    text-align: center;
    position: relative;
    cursor: pointer;
}

#${videoId} .imgStyle {
    max-height: 100%;
    max-width: 100%;
    width: auto;
    height: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}

#${videoId} .icon {
    max-width: 45px;
    position: absolute;  
    width: auto;
    height: auto;
    max-height: 45px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}

#${containerId} {
    height: 100%;
    width: 100%;
    position: relative;
    text-align: center;
}`;

  return style;
};

const getMediaElement = (cueTvVideo, videoId, containerId, watchLinkContainerId, url, videoUrl) => {
  const videoFrameElement = generateVideoFrameElement(videoUrl, cueTvVideo, videoId);
  const thumbnailFrameElement = generateThumbnailFrameElement(cueTvVideo?.thumbnail?.medium, cueTvVideo, videoId, url);
  const watchLinkElement = generateWatchLinkElement(url, watchLinkContainerId);
  const styleElement = generateStyleElement(containerId, videoId, watchLinkContainerId);
  const styleThumbnailElement = generateThumbnailStyleElement(containerId, videoId, watchLinkContainerId);

  const outerContainer = document.createElement('div');
  outerContainer.setAttribute('id', containerId);
  if (cueTvVideo?.is_public) {
    outerContainer.appendChild(videoFrameElement);
    outerContainer.appendChild(watchLinkElement);
    outerContainer.appendChild(styleElement);
  } else {
    outerContainer.appendChild(thumbnailFrameElement);
    outerContainer.appendChild(styleThumbnailElement);
  }

  return outerContainer;
};

class VimeoOTTPlayer extends Component {
  static displayName = 'VimeoOtt';
  static canPlay = url => cueTvMediaUrlRegex.test(url);
  static forceLoad = true; // Prevent checking isLoading when URL changes
  callPlayer = callPlayer;
  duration = null;
  currentTime = null;
  secondsLoaded = null;
  cueTvVideo = {};
  componentDidMount() {
    this.props.onMount && this.props.onMount(this);
  }

  load(url) {
    const slug = url.split('/').pop();
    getVideo({
      lang: 'en',
      limit: 10,
      page: 1,
      video_slug: slug,
    })
      .then(response => {
        const videos = response.data.data;
        if (videos.length == 0) {
          // TODO: , throw some error - or show thumbnail
          this.props.onError('Invalid Link');
          return;
        }

        this.duration = null;
        this.cueTvVideo = videos[0];
        if (!this.container) return;
        const videoId = uuidv4();
        const containerId = uuidv4();
        const watchLinkContainerId = uuidv4();
        const videoUrl = `https://embed.vhx.tv/videos/${this.cueTvVideo.external_key}/?api=1&referrer=${url}&sharing=1&title=0`;

        if (this.cueTvVideo?.is_public) {
          // create an iframe element on container
          const mediaElement = getMediaElement(
            this.cueTvVideo,
            videoId,
            containerId,
            watchLinkContainerId,
            url,
            videoUrl,
          );

          const styleElement = generateStyleElement(containerId, videoId, watchLinkContainerId);
          this.container.appendChild(styleElement);
          this.container.appendChild(mediaElement);
        } else {
          // // create an iframe element on container
          const mediaRedirectElement = getMediaElement(
            this.cueTvVideo,
            videoId,
            containerId,
            watchLinkContainerId,
            url,
            videoUrl,
          );

          const styleElement = generateStyleElement(containerId, videoId, watchLinkContainerId);
          this.container.appendChild(styleElement);
          this.container.appendChild(mediaRedirectElement);
        }
      })
      .catch(err => {
        console.log('resolving media failed :: ', err);
        this.props.onError(err);
      });
  }

  refreshDuration() {}
  play() {
    const promise = this.callPlayer('play');
    if (promise) {
      promise.catch(this.props.onError);
    }
  }
  pause() {
    this.callPlayer('pause');
  }
  stop() {
    this.callPlayer('unload');
  }
  seekTo(seconds) {
    this.callPlayer('setCurrentTime', seconds);
  }
  setVolume(fraction) {
    this.callPlayer('setVolume', fraction);
  }
  setLoop(loop) {
    this.callPlayer('setLoop', loop);
  }
  setPlaybackRate(rate) {
    this.callPlayer('setPlaybackRate', rate);
  }
  mute = () => {
    this.setVolume(0);
  };
  unmute = () => {
    if (this.props.volume !== null) {
      this.setVolume(this.props.volume);
    }
  };
  getDuration() {
    return this.duration;
  }
  getCurrentTime() {
    return this.currentTime;
  }
  getSecondsLoaded() {
    return this.secondsLoaded;
  }

  ref = container => {
    this.container = container;
  };

  render() {
    const { display } = this.props;
    const style = {
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      display,
    };
    return <div key={this.props.url} ref={this.ref} style={style} />;
  }
}

export default VimeoOTTPlayer;
